'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import request from 'superagent';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _user2 = require('redux/modules/user');

var userActions = _interopRequireWildcard(_user2);

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewPassword = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loadingResetPass: state.user.loadingResetPass,
    _user: state.user._user
  };
}, (0, _extends3.default)({}, authActions, userActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(NewPassword, _Component);

  function NewPassword() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NewPassword);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NewPassword.__proto__ || (0, _getPrototypeOf2.default)(NewPassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inputs: {
        password: '',
        confirm_password: ''
      },
      token: _this.props.params.token,
      passwordValidate: true,
      cpValidate: true,
      showModalSuccess: false
    }, _this.onChangePassword = function (event) {
      var passwordValidate = false;
      var cpValidate = true;
      if (event.target.value.length >= 8 || event.target.value === '') {
        passwordValidate = true;
      }
      if (_this.confirm_password.value !== '' && _this.confirm_password.value !== event.target.value) {
        cpValidate = false;
      }
      var inputs = _this.state.inputs;
      inputs.password = event.target.value;
      _this.setState({
        inputs: inputs,
        passwordValidate: passwordValidate,
        cpValidate: cpValidate
      });
    }, _this.onChangeCP = function (event) {
      var cpValidate = false;
      if (event.target.value.length >= 8 && _this.password.value === event.target.value || event.target.value === '') {
        cpValidate = true;
      }
      var inputs = _this.state.inputs;
      inputs.confirm_password = event.target.value;
      _this.setState({
        inputs: inputs,
        cpValidate: cpValidate
      });
    }, _this.handleSubmit = function () {
      var inputs = _this.state.inputs;
      var passwordValidate = _this.password.value.length >= 8;
      var cpValidate = _this.password.value === _this.confirm_password.value;
      if (passwordValidate && cpValidate) {
        inputs.token = _this.state.token;
        _this.props.resetPass(inputs);
      } else {
        _this.setState({
          passwordValidate: passwordValidate,
          cpValidate: cpValidate
        });
      }
    }, _this.handleCloseModalSuccess = function () {
      _this.setState({ showModalSuccess: false });
    }, _this.hanldeOpenModalSuccess = function () {
      _this.setState({ showModalSuccess: true });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NewPassword, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.params.token) {
        _reactRouter.browserHistory.push('/');
      }
      // else {
      //   request.get(`/api/user/check-token?token=${this.props.params.token}`).end((err, res) => {
      //     if (res.body !== null && !res.body.success) {
      //       browserHistory.push('/');
      //     }
      //   });
      // }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.loadingResetPass && !nextProps.loadingResetPass) {
        this.hanldeOpenModalSuccess();
      }
    }
  }, {
    key: 'handleRoute',
    value: function handleRoute() {
      var _props = this.props,
          _user = _props._user,
          setUser = _props.setUser;

      if (_user !== null) {
        setUser(_user);
        _reactRouter.browserHistory.push('/');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./ResetPassword.scss');
      var _state = this.state,
          passwordValidate = _state.passwordValidate,
          cpValidate = _state.cpValidate,
          inputs = _state.inputs,
          showModalSuccess = _state.showModalSuccess;
      var loadingResetPass = this.props.loadingResetPass;

      return _react2.default.createElement(
        'div',
        { className: styles.registerPage + ' container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Reset Password' }),
        loadingResetPass && _react2.default.createElement(_components.Loading, null),
        _react2.default.createElement(
          'div',
          { className: styles.loginContent },
          _react2.default.createElement(
            'div',
            { className: styles.leftContent },
            _react2.default.createElement(
              'div',
              { className: styles.headerLogin },
              _react2.default.createElement(
                'div',
                { className: styles.title },
                'T\u1EA1o M\u1EADt Kh\u1EA9u M\u1EDBi'
              ),
              _react2.default.createElement(
                'span',
                { className: styles.info },
                '\u0110\xE2y l\xE0 l\u1EA7n \u0111\u1EA7u ti\xEAn b\u1EA1n \u0111\u0103ng nh\u1EADp v\xE0o Lookme. ',
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'i',
                  null,
                  'H\xE3y t\u1EA1o ',
                  _react2.default.createElement(
                    'b',
                    null,
                    'm\u1EADt kh\u1EA9u m\u1EDBi'
                  ),
                  ' v\xE0 c\xF9ng t\xECm n\u01A1i l\xE0m \u0111\u1EB9p v\u1EDBi Lookme b\u1EA1n nh\xE9!'
                )
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.FormGroup,
              { className: styles.formGroup },
              passwordValidate === false && _react2.default.createElement(
                'div',
                { className: styles.help },
                'M\u1EADt kh\u1EA9u ph\u1EA3i tr\xEAn 8 k\xFD t\u1EF1!'
              ),
              _react2.default.createElement(
                _reactBootstrap.InputGroup,
                { className: styles.groupInput },
                _react2.default.createElement(
                  _reactBootstrap.InputGroup.Addon,
                  { className: styles.inputIcon },
                  _react2.default.createElement('i', {
                    className: 'fa fa-lock ' + styles.icon,
                    'aria-hidden': 'true'
                  }),
                  _react2.default.createElement(
                    'div',
                    { className: styles.required },
                    '*'
                  )
                ),
                _react2.default.createElement(_reactBootstrap.FormControl, {
                  inputRef: function inputRef(ref) {
                    return _this2.password = ref;
                  },
                  className: styles.inputLogin,
                  minLength: '8',
                  type: 'password',
                  placeholder: 'M\u1EADt kh\u1EA9u',
                  onChange: this.onChangePassword,
                  value: inputs.password
                })
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.FormGroup,
              { className: styles.formGroup },
              cpValidate === false && _react2.default.createElement(
                'div',
                { className: styles.help },
                'M\u1EADt kh\u1EA9u kh\xF4ng tr\u1EEBng kh\u1EDBp!'
              ),
              _react2.default.createElement(
                _reactBootstrap.InputGroup,
                { className: styles.groupInput },
                _react2.default.createElement(
                  _reactBootstrap.InputGroup.Addon,
                  { className: styles.inputIcon },
                  _react2.default.createElement('i', {
                    className: 'fa fa-lock ' + styles.icon,
                    'aria-hidden': 'true'
                  }),
                  _react2.default.createElement(
                    'div',
                    { className: styles.required },
                    '*'
                  )
                ),
                _react2.default.createElement(_reactBootstrap.FormControl, {
                  inputRef: function inputRef(ref) {
                    return _this2.confirm_password = ref;
                  },
                  className: styles.inputLogin,
                  minLength: '8',
                  type: 'password',
                  placeholder: 'X\xE1c nh\u1EADn m\u1EADt kh\u1EA9u',
                  onChange: this.onChangeCP,
                  value: inputs.confirm_password
                })
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: styles.buttonLogin,
                onClick: function onClick() {
                  return _this2.handleSubmit();
                }
              },
              'T\u1EA1o M\u1EADt Kh\u1EA9u M\u1EDBi'
            )
          ),
          _react2.default.createElement('div', { className: styles.rightContent })
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showModalSuccess,
            hide: this.handleCloseModalSuccess,
            className: 'modal-alert-login'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'close-modal-button',
              onClick: this.handleCloseModalSuccess
            },
            _react2.default.createElement('i', { className: 'fa fa-times' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalAlert },
            _react2.default.createElement(
              'div',
              { className: styles.headerAlert },
              'Th\xF4ng b\xE1o'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.contentAlert },
              'T\u1EA1o m\u1EDBi m\u1EADt kh\u1EA9u th\xE0nh c\xF4ng'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.actionButtons },
              _react2.default.createElement(
                'div',
                { onClick: this.handleRoute.bind(this) },
                _react2.default.createElement(
                  'div',
                  { className: styles.btnLogin },
                  'X\xE1c nh\u1EADn'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return NewPassword;
}(_react.Component), _class2.propTypes = {
  params: _react.PropTypes.object,
  _user: _react.PropTypes.object,
  loadingResetPass: _react.PropTypes.bool,
  resetPass: _react.PropTypes.func,
  setUser: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = NewPassword;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Register/NewPassword.js
// module id = 1691
// module chunks = 0